import { render, staticRenderFns } from "./AttachmentsGeneratedNotification.vue?vue&type=template&id=0d1fa0d8&scoped=true&"
import script from "./AttachmentsGeneratedNotification.vue?vue&type=script&lang=js&"
export * from "./AttachmentsGeneratedNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1fa0d8",
  null
  
)

export default component.exports